import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { catchError, concatMap, filter, map, mergeMap, of, switchMap, withLatestFrom } from "rxjs";
import { AutomationActions, AutomationSelectors } from ".";
import { AutomationApiService } from "../../../services/automation-api.service";
import { CoreSelectors } from "../../core";
import { ClientDeviceLog } from "@prism/prism-shared";
import { AppwriteDatabaseService } from '@prism/angular-shared';


@Injectable({ providedIn: 'root' })
export class AutomationEffects {

    constructor(
        public store: Store,
        private actions$: Actions,
        private automationApiService: AutomationApiService,
        private appwriteDb: AppwriteDatabaseService,
    ) { }

    // private appendTimestamp<T>(
    //     accessor: (obj: Record<string, T>) => T,
    // ) {
    //     return pipe(
    //         map(accessor),
    //         withLatestFrom(this.store.select(CoreSelectors.getCurrentUser)),
    //         map(([entity, currentUser]) => ({
    //             ...entity,
    //             lastSavedOn: new Date(),
    //             lastSavedById: currentUser.id
    //         }))
    //     )
    // }


    LoadTags$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.LoadTags.initial),
        switchMap(() => this.automationApiService.loadTags().pipe(
            map((tags) => AutomationActions.LoadTags.success({ tags })),
            catchError(error => of(AutomationActions.LoadTags.failure({ error })))
        ))
    ))

    SetFactoryNode$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.SetFactoryNode.initial),
        switchMap(({ factoryNode }) => this.automationApiService.setFactoryNode(factoryNode).pipe(
            map(() => AutomationActions.SetFactoryNode.success({ factoryNode })),
            catchError(error => of(AutomationActions.SetFactoryNode.failure({ error })))
        ))
    ))

    LoadFactoryNodeById$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.LoadFactoryNodeById.initial),
        switchMap(({ factoryNodeId }) => this.automationApiService.loadFactoryNodeById(factoryNodeId).pipe(
            map((factoryNode) => AutomationActions.LoadFactoryNodeById.success({ factoryNode })),
            catchError(error => of(AutomationActions.LoadFactoryNodeById.failure({ error })))
        ))
    ))

    LoadFactoryNodes$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.LoadFactoryNodes.initial),
        switchMap(() => this.automationApiService.loadFactoryNodes().pipe(
            map((factoryNodes) => AutomationActions.LoadFactoryNodes.success({ factoryNodes })),
            catchError(error => of(AutomationActions.LoadFactoryNodes.failure({ error })))
        ))
    ))

    SetFactoryNodeConfig$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.SetFactoryNodeConfig.initial),
        switchMap(({ factoryNodeConfig }) => this.automationApiService.setFactoryNodeConfig(factoryNodeConfig).pipe(
            map(() => AutomationActions.SetFactoryNodeConfig.success({ factoryNodeConfig })),
            catchError(error => of(AutomationActions.SetFactoryNodeConfig.failure({ error })))
        ))
    ))

    LoadFactoryNodeConfigById$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.LoadFactoryNodeConfigById.initial),
        switchMap(({ factoryNodeConfigId }) => this.automationApiService.loadFactoryNodeConfigById(factoryNodeConfigId).pipe(
            map((factoryNodeConfig) => AutomationActions.LoadFactoryNodeConfigById.success({ factoryNodeConfig })),
            catchError(error => of(AutomationActions.LoadFactoryNodeConfigById.failure({ error })))
        ))
    ))

    LoadFactoryNodeConfigsByIds$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.LoadFactoryNodeConfigsByIds.initial),
        switchMap(({ factoryNodeConfigIds }) => this.automationApiService.loadFactoryNodeConfigsByIds(factoryNodeConfigIds).pipe(
            map((factoryNodeConfigs) => AutomationActions.LoadFactoryNodeConfigsByIds.success({ factoryNodeConfigs })),
            catchError(error => of(AutomationActions.LoadFactoryNodeConfigsByIds.failure({ error })))
        ))
    ))

    LoadFactoryNodeConfigsByFactoryNodeId$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.LoadFactoryNodeConfigsByFactoryNodeId.initial),
        switchMap(({ factoryNodeId }) => this.automationApiService.loadFactoryNodeConfigsByFactoryNodeId(factoryNodeId).pipe(
            map((factoryNodeConfigs) => AutomationActions.LoadFactoryNodeConfigsByFactoryNodeId.success({ factoryNodeConfigs })),
            catchError(error => of(AutomationActions.LoadFactoryNodeConfigsByFactoryNodeId.failure({ error })))
        ))
    ))

    SetRobotProgramGroup$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.SetRobotProgramGroup.initial),
        switchMap(({ programGroup }) => this.automationApiService.setRobotProgramGroup(programGroup).pipe(
            map(() => AutomationActions.SetRobotProgramGroup.success({ programGroup })),
            catchError(error => of(AutomationActions.SetRobotProgramGroup.failure({ error })))
        ))
    ))

    LoadRobotProgramGroups$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.LoadRobotProgramGroups.initial),
        switchMap(() => this.automationApiService.loadRobotProgramGroups().pipe(
            map((programGroups) => AutomationActions.LoadRobotProgramGroups.success({ programGroups })),
            catchError(error => of(AutomationActions.LoadRobotProgramGroups.failure({ error })))
        ))
    ))

    LoadRobotProgramGroupById$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.LoadRobotProgramGroupById.initial),
        switchMap(({ programGroupId }) => this.automationApiService.loadRobotProgramGroupById(programGroupId).pipe(
            map((programGroup) => AutomationActions.LoadRobotProgramGroupById.success({ programGroup })),
            catchError(error => of(AutomationActions.LoadRobotProgramGroupById.failure({ error })))
        ))
    ))

    LoadRobotProgramsByRobotProgramGroupId$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.LoadRobotProgramsByRobotProgramGroupId.initial),
        switchMap(({ programGroupId }) => this.automationApiService.loadRobotProgramsByRobotProgramGroupId(programGroupId).pipe(
            map((programs) => AutomationActions.LoadRobotProgramsByRobotProgramGroupId.success({ programs })),
            catchError(error => of(AutomationActions.LoadRobotProgramsByRobotProgramGroupId.failure({ error })))
        ))
    ))

    LoadRobotProgramById$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.LoadRobotProgramById.initial),
        switchMap(({ programId }) => this.automationApiService.loadRobotProgramById(programId).pipe(
            map((program) => AutomationActions.LoadRobotProgramById.success({ program })),
            catchError(error => of(AutomationActions.LoadRobotProgramById.failure({ error })))
        ))
    ))

    DeleteRobotProgram$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.DeleteRobotProgram.initial),
        switchMap(({ programId }) => this.automationApiService.deleteRobotProgram(programId).pipe(
            map(() => AutomationActions.DeleteRobotProgram.success({ programId })),
            catchError(error => of(AutomationActions.DeleteRobotProgram.failure({ error })))
        ))
    ))

    SetClientDevice$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.SetClientDevice.initial),
        switchMap(({ clientDevice }) => this.automationApiService.setClientDevice(clientDevice).pipe(
            map(() => AutomationActions.SetClientDevice.success({ clientDevice })),
            catchError(error => of(AutomationActions.SetClientDevice.failure({ error })))
        ))
    ))

    SetLabelPrinter$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.SetLabelPrinter.initial),
        switchMap(({ labelPrinter }) => this.automationApiService.setLabelPrinter(labelPrinter).pipe(
            map(() => AutomationActions.SetLabelPrinter.success({ labelPrinter })),
            catchError(error => of(AutomationActions.SetLabelPrinter.failure({ error })))
        ))
    ))

    LoadClientDevices$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.LoadClientDevices.initial),
        switchMap(() => this.automationApiService.loadClientDevices().pipe(
            map((clientDevices) => AutomationActions.LoadClientDevices.success({ clientDevices })),
            catchError(error => of(AutomationActions.LoadClientDevices.failure({ error })))
        ))
    ))

    LoadLabelPrinters$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.LoadLabelPrinters.initial),
        switchMap(() => this.automationApiService.loadLabelPrinters().pipe(
            map((labelPrinters) => AutomationActions.LoadLabelPrinters.success({ labelPrinters })),
            catchError(error => of(AutomationActions.LoadLabelPrinters.failure({ error })))
        ))
    ))

    LoadLabelPrinterGroups$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.LoadLabelPrinterGroups.initial),
        switchMap(() => this.automationApiService.loadLabelPrinterGroups().pipe(
            map((labelPrinterGroups) => AutomationActions.LoadLabelPrinterGroups.success({ labelPrinterGroups })),
            catchError(error => of(AutomationActions.LoadLabelPrinterGroups.failure({ error })))
        ))
    ))

    SetLabelPrinterGroup$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.SetLabelPrinterGroup.initial),
        switchMap(({ labelPrinterGroup }) => this.automationApiService.setLabelPrinterGroup(labelPrinterGroup).pipe(
            map(() => AutomationActions.SetLabelPrinterGroup.success({ labelPrinterGroup })),
            catchError(error => of(AutomationActions.SetLabelPrinterGroup.failure({ error })))
        ))
    ))

    DeleteLabelPrinterGroup$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.DeleteLabelPrinterGroup.initial),
        switchMap(({ labelPrinterGroupId }) => this.automationApiService.deleteLabelPrinterGroup(labelPrinterGroupId).pipe(
            map(() => AutomationActions.DeleteLabelPrinterGroup.success({ labelPrinterGroupId })),
            catchError(error => of(AutomationActions.DeleteLabelPrinterGroup.failure({ error })))
        ))
    ))

    LoadClientDeviceById$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.LoadClientDeviceById.initial),
        switchMap(({ clientDeviceId }) => this.automationApiService.loadClientDeviceById(clientDeviceId).pipe(
            map((clientDevice) => AutomationActions.LoadClientDeviceById.success({ clientDevice })),
            catchError(error => of(AutomationActions.LoadClientDeviceById.failure({ error })))
        ))
    ))

    SetClientDeviceLog$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.SetClientDeviceLog.initial),
        withLatestFrom(this.store.select(CoreSelectors.getCurrentClientDevice)),
        filter(([_, device]) => !!device),
        map(([{ log, location }, device]) => {
            const clientDeviceLog: ClientDeviceLog = {
                id: this.appwriteDb.createId(),
                message: log,
                location,
                clientDeviceId: device!.id,
                timestamp: new Date(),
            }
            return clientDeviceLog;
        }),
        concatMap((clientDeviceLog) => this.automationApiService.setClientDeviceLog(clientDeviceLog).pipe(
            map(() => AutomationActions.SetClientDeviceLog.success()),
            catchError(error => of(AutomationActions.SetClientDeviceLog.failure({ error })))
        ))
    ))

    setUserTimeSession$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.SetUserTimeSession.initial),
        mergeMap(({ userTimeSession }) => this.automationApiService.setUserTimeSession(userTimeSession).pipe(
            map(() => AutomationActions.SetUserTimeSession.success({ userTimeSession })),
            catchError((error) => of(AutomationActions.SetUserTimeSession.failure({ error })))
        ))
    ))

    setUserTimeSessions$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.SetUserTimeSessions.initial),
        mergeMap(({ userTimeSessions }) => this.automationApiService.setUserTimeSessions(userTimeSessions).pipe(
            map(() => AutomationActions.SetUserTimeSessions.success({ userTimeSessions })),
            catchError((error) => of(AutomationActions.SetUserTimeSessions.failure({ error })))
        ))
    ))

    loadUserTimeSessions$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.LoadUserTimeSessions.initial),
        mergeMap(() => this.automationApiService.loadUserTimeSessions().pipe(
            map((userTimeSessions) => AutomationActions.LoadUserTimeSessions.success({ userTimeSessions })),
            catchError((error) => of(AutomationActions.LoadUserTimeSessions.failure({ error })))
        ))
    ))

    deleteUserTimeSession$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.DeleteUserTimeSessions.initial),
        mergeMap(({ userTimeSessionId }) => this.automationApiService.deleteUserTimeSession(userTimeSessionId).pipe(
            map(() => AutomationActions.DeleteUserTimeSessions.success({ userTimeSessionId })),
            catchError((error) => of(AutomationActions.DeleteUserTimeSessions.failure({ error })))
        ))
    ))

    loadUserTimeSessionsByIds$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.LoadUserTimeSessionsByIds.initial),
        mergeMap(({ userTimeSessionIds }) => this.automationApiService.loadUserTimeSessionsByIds(userTimeSessionIds).pipe(
            map((userTimeSessions) => AutomationActions.LoadUserTimeSessionsByIds.success({ userTimeSessions })),
            catchError((error) => of(AutomationActions.LoadUserTimeSessionsByIds.failure({ error })))
        ))
    ))

    SetSoftwareTask$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.SetSoftwareTask.initial),
        mergeMap(({ softwareTask }) => this.automationApiService.setSoftwareTask(softwareTask).pipe(
            map(() => AutomationActions.SetSoftwareTask.success({ softwareTask })),
            catchError((error) => of(AutomationActions.SetSoftwareTask.failure({ error })))
        ))
    ))

    LoadSoftwareTasks$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.LoadSoftwareTasks.initial),
        mergeMap(() => this.automationApiService.loadSoftwareTasks().pipe(
            map((softwareTasks) => AutomationActions.LoadSoftwareTasks.success({ softwareTasks })),
            catchError((error) => of(AutomationActions.LoadSoftwareTasks.failure({ error })))
        ))
    ))

    SetEngineeringUpdateMeeting$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.SetEngineeringUpdateMeeting.initial),
        mergeMap(({ engineeringUpdateMeeting }) => this.automationApiService.setEngineeringUpdateMeeting(engineeringUpdateMeeting).pipe(
            map(() => AutomationActions.SetEngineeringUpdateMeeting.success({ engineeringUpdateMeeting })),
            catchError((error) => of(AutomationActions.SetEngineeringUpdateMeeting.failure({ error })))
        ))
    ))

    LoadEngineeringUpdateMeetings$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.LoadEngineeringUpdateMeetings.initial),
        mergeMap(() => this.automationApiService.loadEngineeringUpdateMeetings().pipe(
            map((engineeringUpdateMeetings) => AutomationActions.LoadEngineeringUpdateMeetings.success({ engineeringUpdateMeetings })),
            catchError((error) => of(AutomationActions.LoadEngineeringUpdateMeetings.failure({ error })))
        ))
    ))

    LoadEngineeringUpdateMeetingById$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.LoadEngineeringUpdateMeetingById.initial),
        mergeMap(({ meetingId }) => this.automationApiService.loadEngineeringUpdateMeetingById(meetingId).pipe(
            map((engineeringUpdateMeeting) => AutomationActions.LoadEngineeringUpdateMeetingById.success({ engineeringUpdateMeeting })),
            catchError((error) => of(AutomationActions.LoadEngineeringUpdateMeetingById.failure({ error })))
        ))
    ))

    SetEngineeringUpdateMeetingUserContents$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.SetEngineeringUpdateMeetingUserContents.initial),
        mergeMap(({ engineeringUpdateMeetingUserContents }) => this.automationApiService.setEngineeringUpdateMeetingUserContents(engineeringUpdateMeetingUserContents).pipe(
            map(() => AutomationActions.SetEngineeringUpdateMeetingUserContents.success({ engineeringUpdateMeetingUserContents })),
            catchError((error) => of(AutomationActions.SetEngineeringUpdateMeetingUserContents.failure({ error })))
        ))
    ))
    SetEngineeringUpdateMeetingUserContent$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.SetEngineeringUpdateMeetingUserContent.initial),
        mergeMap(({ engineeringUpdateMeetingUserContent }) => this.automationApiService.setEngineeringUpdateMeetingUserContent(engineeringUpdateMeetingUserContent).pipe(
            map(() => AutomationActions.SetEngineeringUpdateMeetingUserContent.success({ engineeringUpdateMeetingUserContent })),
            catchError((error) => of(AutomationActions.SetEngineeringUpdateMeetingUserContent.failure({ error })))
        ))
    ))


    LoadEngineeringUpdateMeetingUserContents$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.LoadEngineeringUpdateMeetingUserContents.initial),
        mergeMap(() => this.automationApiService.loadEngineeringUpdateMeetingUserContents().pipe(
            map((engineeringUpdateMeetingUserContents) => AutomationActions.LoadEngineeringUpdateMeetingUserContents.success({ engineeringUpdateMeetingUserContents })),
            catchError((error) => of(AutomationActions.LoadEngineeringUpdateMeetingUserContents.failure({ error })))
        ))
    ))

    LoadEngineeringUpdateMeetingUserContentsByMeetingId$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.LoadEngineeringUpdateMeetingUserContentsByMeetingId.initial),
        mergeMap(({ meetingId }) => this.automationApiService.loadEngineeringUpdateMeetingUserContentsByMeetingId(meetingId).pipe(
            map((engineeringUpdateMeetingUserContents) => AutomationActions.LoadEngineeringUpdateMeetingUserContentsByMeetingId.success({ engineeringUpdateMeetingUserContents })),
            catchError((error) => of(AutomationActions.LoadEngineeringUpdateMeetingUserContentsByMeetingId.failure({ error })))
        ))
    ))

    DeleteEngineeringUpdateMeetingUserContent$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.DeleteEngineeringUpdateMeetingUserContent.initial),
        mergeMap(({ engineeringUpdateMeetingUserContent }) => this.automationApiService.deleteEngineeringUpdateMeetingUserContent(engineeringUpdateMeetingUserContent).pipe(
            map(() => AutomationActions.DeleteEngineeringUpdateMeetingUserContent.success({ engineeringUpdateMeetingUserContent })),
            catchError((error) => of(AutomationActions.DeleteEngineeringUpdateMeetingUserContent.failure({ error })))
        ))
    ))

    LoadKnowledgeDocuments$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.LoadKnowledgeDocuments.initial),
        mergeMap(() => this.automationApiService.loadKnowledgeDocuments().pipe(
            map((knowledgeDocuments) => AutomationActions.LoadKnowledgeDocuments.success({ knowledgeDocuments })),
            catchError((error) => of(AutomationActions.LoadKnowledgeDocuments.failure({ error })))
        ))
    ))

    LoadKnowledgeDocumentsById$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.LoadKnowledgeDocumentById.initial),
        mergeMap(({ documentId }) => this.automationApiService.loadKnowledgeDocumentById(documentId).pipe(
            map((knowledgeDocument) => AutomationActions.LoadKnowledgeDocumentById.success({ knowledgeDocument })),
            catchError((error) => of(AutomationActions.LoadKnowledgeDocumentById.failure({ error })))
        ))
    ))

    SetKnowledgeDocument$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.SetKnowledgeDocument.initial),
        mergeMap(({ knowledgeDocument }) => this.automationApiService.setKnowledgeDocument(knowledgeDocument).pipe(
            map(() => AutomationActions.SetKnowledgeDocument.success({ knowledgeDocument })),
            catchError((error) => of(AutomationActions.SetKnowledgeDocument.failure({ error })))
        ))
    ))

    DeleteKnowledgeDocumentById$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.DeleteKnowledgeDocumentById.initial),
        mergeMap(({ documentId }) => this.automationApiService.deleteKnowledgeDocumentById(documentId).pipe(
            map(() => AutomationActions.DeleteKnowledgeDocumentById.success({ documentId })),
            catchError((error) => of(AutomationActions.DeleteKnowledgeDocumentById.failure({ error })))
        ))
    ))

    // --- Automation Hardware Items (UX: "components") ---

    LoadAutomationHardwareItems$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.LoadAutomationHardwareItems.initial),
        switchMap(() => this.automationApiService.loadAutomationHardwareItems().pipe(
            map((automationHardwareItems) => AutomationActions.LoadAutomationHardwareItems.success({ automationHardwareItems })),
            catchError((error) => of(AutomationActions.LoadAutomationHardwareItems.failure({ error })))
        ))
    ))

    LoadAutomationHardwareItemById$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.LoadAutomationHardwareItemById.initial),
        switchMap(({ automationHardwareItemId }) => this.automationApiService.loadAutomationHardwareItemById(automationHardwareItemId).pipe(
            map((automationHardwareItem) => AutomationActions.LoadAutomationHardwareItemById.success({ automationHardwareItem })),
            catchError((error) => of(AutomationActions.LoadAutomationHardwareItemById.failure({ error })))
        ))
    ))

    SetAutomationHardwareItem$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.SetAutomationHardwareItem.initial),
        mergeMap(({ automationHardwareItem }) => this.automationApiService.setAutomationHardwareItem(automationHardwareItem).pipe(
            map(() => AutomationActions.SetAutomationHardwareItem.success({ automationHardwareItem })),
            catchError((error) => of(AutomationActions.SetAutomationHardwareItem.failure({ error })))
        ))
    ))

    DeleteAutomationHardwareItem$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.DeleteAutomationHardwareItem.initial),
        mergeMap(({ automationHardwareItemId }) => this.automationApiService.deleteAutomationHardwareItem(automationHardwareItemId).pipe(
            map(() => AutomationActions.DeleteAutomationHardwareItem.success({ automationHardwareItemId })),
            catchError((error) => of(AutomationActions.DeleteAutomationHardwareItem.failure({ error })))
        ))
    ))

    LoadAutomationVendorHardwareDataByHardwareItemId$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.LoadAutomationVendorHardwareDataByHardwareItemId.initial),
        mergeMap(({ hardwareItemId }) => this.automationApiService.loadAutomationVendorHardwareDataByHardwareItemId(hardwareItemId).pipe(
            map((automationVendorHardwareData) => AutomationActions.LoadAutomationVendorHardwareDataByHardwareItemId.success({ automationVendorHardwareData })),
            catchError((error) => of(AutomationActions.LoadAutomationVendorHardwareDataByHardwareItemId.failure({ error })))
        ))
    ))

    SetAutomationVendorHardwareData$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.SetAutomationVendorHardwareData.initial),
        mergeMap(({ automationVendorHardwareData }) => this.automationApiService.setAutomationVendorHardwareData(automationVendorHardwareData).pipe(
            map(() => AutomationActions.SetAutomationVendorHardwareData.success({ automationVendorHardwareData })),
            catchError((error) => of(AutomationActions.SetAutomationVendorHardwareData.failure({ error })))
        ))
    ))

    DeleteAutomationVendorHardwareData$ = createEffect(() => this.actions$.pipe(
        ofType(AutomationActions.DeleteAutomationVendorHardwareData.initial),
        mergeMap(({ automationVendorHardwareDataId }) => this.automationApiService.deleteAutomationVendorHardwareData(automationVendorHardwareDataId).pipe(
            map(() => AutomationActions.DeleteAutomationVendorHardwareData.success({ automationVendorHardwareDataId })),
            catchError((error) => of(AutomationActions.DeleteAutomationVendorHardwareData.failure({ error })))
        ))
    ))
}
